import { inverseMap } from './data';

export const getInverseColor = (color: string) =>
    inverseMap?.[color] || 'primary';
